var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hit_login',[_c('hit_dashboard',[_c('div',{staticClass:"hit-container"},[(_vm.data)?_c('importData',{attrs:{"data":_vm.data}}):_c('loginForm',{attrs:{"callback":function(data){ _vm.setData(data); }}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }